import { shellStringResources } from '../../Resources/ShellStringResources';
import { Metamodel } from '../base/model';
import { SalesforceV2Dataset } from '../dataset/salesforce-v2.dataset';
import { ModelConstants } from '../model-constants';
import { SalesforceSink } from './salesforce.copysink';
import { writeBehaviorOptionValues, UpdateMethod, UpdateMethodType } from '../../constants/write-behavior-constants';
import { compact, head } from 'lodash';
import { ICopySinkWithUpdateMethod } from '../copysink/copysink';

@Metamodel.model({
    name: ModelConstants.salesforceV2CopySink,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SalesforceV2Dataset) }
})
export class SalesforceV2Sink extends SalesforceSink implements ICopySinkWithUpdateMethod {
    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: shellStringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 100000;

    public get updateMethod(): UpdateMethodType {
        switch (this.writeBehavior) {
            case writeBehaviorOptionValues.insert:
                return UpdateMethod.Append;
            case writeBehaviorOptionValues.upsert:
                return UpdateMethod.Upsert;
            default:
                return undefined;
        }
    }
    
    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Append:
                this.writeBehavior = writeBehaviorOptionValues.insert;
                break;
            case UpdateMethod.Upsert:
                this.writeBehavior = writeBehaviorOptionValues.upsert;
                break;
            default:
                this.writeBehavior = writeBehaviorOptionValues.insert;
        }
    }

    public get upsertKeyColumns() {
        return compact([this.externalIdFieldName]);
    }
    
    public set upsertKeyColumns(value: string[]) {
        this.externalIdFieldName = head(value);
    }
}
